module.exports = __webpack_public_path__ + "img/location-marker-2.d1691698.svg";